module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.showLogoutNotification) ? _c('logout-notification') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 offset-lg-3 col-md-8 offset-md-2 card",
    attrs: {
      "id": "login-card"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_vm._m(0), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.login.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Username")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "form-control mb-4",
    attrs: {
      "type": "text",
      "name": "username",
      "autofill": "username",
      "autocomplete": "on"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group mb-5"
  }, [_c('label', [_vm._v("Password")]), _vm._v(" "), (_vm.passwordFieldType === 'password') ? _c('b-icon-eye-slash-fill', {
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.switchVisibility
    }
  }) : _vm._e(), _vm._v(" "), (_vm.passwordFieldType === 'text') ? _c('b-icon-eye-fill', {
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.switchVisibility
    }
  }) : _vm._e(), _vm._v(" "), ((_vm.passwordFieldType) === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "password",
      "autofill": "password",
      "type": "password",
      "autocomplete": "on",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.password) ? _vm._i(_vm.password, null) > -1 : (_vm.password)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.password,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.password = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.password = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.password = $$c
        }
      }
    }
  }) : ((_vm.passwordFieldType) === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "password",
      "autofill": "password",
      "type": "password",
      "autocomplete": "on",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.password, null)
    },
    on: {
      "change": function($event) {
        _vm.password = null
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "password",
      "autofill": "password",
      "type": "password",
      "autocomplete": "on",
      "type": _vm.passwordFieldType
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })], 1), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-sm btn-light mt-2",
    attrs: {
      "to": "username-recovery"
    }
  }, [_vm._v("Login Help")]), _c('span', [_vm._v(" ")])], 1)]), _vm._v(" "), _c('change-password-modal')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "mb-4",
    attrs: {
      "id": "xmcp-title"
    }
  }, [_c('span', [_vm._v("XMission")]), _vm._v(" Control Panel")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn float-right btn-primary btn-lg",
    attrs: {
      "type": "submit"
    }
  }, [_c('b', [_vm._v("Log In")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e0d39240","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Login.vue
// module id = 1593
// module chunks = 5